import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading:true,
    globales:{
      path_web:'',
      name_year:'',
    },
    empresa:{
      razon_social:"",
      abreviatura:"",
      ruc:"",
      telefonos:null,
      logo:null,
      pagina_web:null,
      path_file_logo:"",
      sucursales:[],
      redes_sociales:[],
    },
    redes_sociales:[],
    notificaciones:[],
  },
  mutations: {
    setGlobales:(state,obj)=>{
      Vue.set(state,'globales',obj);
    },
    setLoading:(state,value)=>{
      Vue.set(state,'loading',value);
    },
    setEmpresa:(state,obj)=>{
      Vue.set(state,'empresa',obj);
      localStorage.setItem('empresa', JSON.stringify(obj));
    },
    setRedesSociales:(state,obj)=>{
      //Vue.set(state,'redes_sociales',obj);
    },
    setNotificacion:(state, obj)=>{
      Vue.set(state,'notificaciones',obj);
      localStorage.setItem('notificaciones', JSON.stringify(obj));
    },
  },
  actions: {
    loadObjEmpresa({commit, dispatch, getters}){
      let ObjEmpresa= localStorage.getItem('empresa');
      
      if(ObjEmpresa){
        ObjEmpresa = JSON.parse(ObjEmpresa);
        commit('setEmpresa',ObjEmpresa);
      }
    },
    loadObjNotificacion({commit, dispatch, getters}){
      let ObjNotificacion = localStorage.getItem('notificaciones');
      if(ObjNotificacion){
        ObjNotificacion = JSON.parse(ObjNotificacion);
        commit('setNotificacion',ObjNotificacion);
      }
    },
  },
  modules: {
  }
})
